import { setFacilityClaims, showSnackbar } from "store/actions";

export const compareArrays = (array1, array2) => {
  if (array1.length === array2.length) {
    return array1.every((element) => {
      if (array2.includes(element)) {
        return true;
      }
      return false;
    });
  }
  return false;
};

export const getTagsArray = (tags) => {
  if (!tags) return [];
  return (
    tags
      ?.trim()
      ?.split(" ")
      ?.map((tag) => tag.slice(1)) || []
  );
};

export const getMimeType = (ext, default_ = "application/pdf") => {
  return (
    {
      png: "image/png",
      jpeg: "image/jpeg",
      jpg: "image/jpg",
      pdf: "application/pdf",
    }[ext] || default_
  );
};

export const updatedFields = (touchedFields, dataFields) => {
  return Object.keys(dataFields).reduce((acc, curr) => {
    if (touchedFields[curr]) acc[curr] = dataFields[curr];
    return acc;
  }, {});
};

export const downloadFile = ({ response, filename }) => {
  const blob = new Blob([response.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const openFileInWindow = ({ response, ext }) => {
  const blob = new Blob([response.data], { type: getMimeType(ext) });
  const url = window.URL.createObjectURL(blob);

  const newWindow = window.open(
    "",
    "_blank",
    "location=yes,height=570,width=520,scrollbars=yes,status=yes"
  );

  if (newWindow) {
    newWindow.document.write(
      `<iframe src="${url}" frameborder="0" style="border: none; width: 100%; height: 100%;" allowfullscreen></iframe>`
    );
  } else {
    console.error(
      "Failed to open new window (probably blocked by popup blocker)"
    );
  }
};

export const openLinkInNewWinodow = (link) =>
  window.open(link, "_blank", "noopener,noreferrer");

export const copyToClipboard = (text, dispatch) => {
  navigator.clipboard.writeText(text);
  if (dispatch) dispatch(showSnackbar("Copied to clipboard", 1000));
};

export const mapCodeData = (fields, facilityClaims, dispatch) => {
  const fieldValuesBatch = [];

  for (const key in facilityClaims) {
    fields.forEach((item) => {
      const numberOfFields = Array.from(
        { length: item.fieldLength },
        (_, i) => i + 1
      );

      numberOfFields.forEach((data) => {
        const firstKey = `${item.firstKey}${data}`;
        const secondKey = `${item.secondKey}${data}`;
        const thirdKey = `${item.thirdKey}${data}`;

        if (key === firstKey || key === secondKey || key === thirdKey) {
          const fieldValues = {
            [`${firstKey}`]: facilityClaims?.[firstKey],
            fieldName: item.fieldName,
            id: data,
          };

          // Handle second field type
          switch (item.secondFieldType) {
            case "date":
              fieldValues[secondKey] = facilityClaims?.[secondKey] || "";
              break;
            case "from_date":
              fieldValues[secondKey] = facilityClaims?.[secondKey] || "";
              fieldValues[thirdKey] = facilityClaims?.[thirdKey] || "";
              break;
            case "text":
              fieldValues[secondKey] = facilityClaims?.[secondKey] || "";
              break;
            default:
              break;
          }
          fieldValuesBatch.push(fieldValues);
        }
      });
    });
  }

  // Dispatch all updates at once
  dispatch(setFacilityClaims(fieldValuesBatch));
};

export const sortStringArray = (
  arr,
  mode = "asc",
  value = false,
  isDate = false
) =>
  !mode || mode === "asc"
    ? arr.sort((a, b) => {
        const firstString = value ? a[value] : a;
        const secondString = value ? b[value] : b;
        if (!firstString) return 1;
        if (!secondString) return -1;
        if (isDate) return new Date(firstString) - new Date(secondString);
        return firstString?.localeCompare(secondString);
      })
    : arr.sort((a, b) => {
        const firstString = value ? a[value] : a;
        const secondString = value ? b[value] : b;
        if (!firstString) return 1;
        if (!secondString) return -1;
        if (isDate) return new Date(secondString) - new Date(firstString);
        return secondString?.localeCompare(firstString);
      });
